import React, { useState, useEffect } from "react";
import TableLoader from "shared/TableLoader";
import { CardHeader, Col, Input, Label, Row,Spinner } from "reactstrap";
import CustomTextField from "components/CustomTextField";
import Select from "react-select";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import { selectCurrentRoles, selectCurrentToken, selectCurrentUser } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import { useGetIfscQuery } from "services/BankBranchesApiSlice";
import { API_URL } from "app/config";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";

const SaathiBankDetails = ({ SaathiUserData, SaathiDetailsRefetch }) => {
  const {id} =useParams()
  const user_token = useSelector(selectCurrentToken);
  const currentUser = useSelector(selectCurrentUser);
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [isEdit, setisEdit] = useState(false);
  const { handleSubmit, reset } = useForm();
  const [AccountType, setAccountType] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [loader,setLoader]=useState(false)

  const [bankIfscCodeList, setIfscCodeList] = useState({
    branchName: "",
    bankName: "",
  });
  const [BankIfscOptions, setBankIfscOptions] = useState('');
  const [bankIfscCode, setIfscCode] = useState("");
  const { data: bankIfsc } = useGetIfscQuery(bankIfscCode);
  useEffect(() => {
    if (bankIfsc) {
      let bankList = [];
      bankIfsc.data.results.map((bank) => {
        bankList.push({
          value: bank.branch_name,
          label: bank.IFSC,
          branchName: bank.branch_name,
          bankName: bank.bank_name,
        });
      });
      setBankIfscOptions(bankList);
    }
  }, [bankIfsc]);

  const onIfscChange = (e) => {
    setIfscCode(e.label);
    setIfscCodeList(e);
  };
  const onIfscKeyUp = (e) => {
    setIfscCode(e.target.value);
  };
  function handleAccountType(AccountType) {
    setAccountType(AccountType);
  }
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const [BankingDetails, setBankingDetails] = useState({
    account_holder_name: "",
    account_number: "",
  });




  const onInputChange = (event) => {
    setBankingDetails({
      ...BankingDetails,
      [event.target.name]: event.target.value,
    });
  };
  // console.log("runn 2" , BankingDetails )
    // AccountType
    const AccountTypeListData = [
      {
        label: "Account Type",
        options: [
          { value: "saving", label: "Savings Account " },
          { value: "current", label: "Current Account" },
          { value: "others", label: "Other Account" },
        ],
      },
    ];
    // console.log(SaathiUserData.bank_details , "data")


    const onSubmitSaathiData = (e) => {
      setLoader(true)
      var formData = new FormData();
      formData.append("account_holder_name", BankingDetails.account_holder_name  || SaathiUserData?.bank_details?.account_holder_name);
      formData.append("account_number", BankingDetails.account_number  || SaathiUserData?.bank_details?.account_number);
      formData.append("account_type", AccountType || SaathiUserData?.bank_details?.account_type);
      formData.append("ifsc_code", bankIfscCode || SaathiUserData?.bank_details?.ifsc_code);
      formData.append("bank_name", bankIfscCodeList?.bankName || SaathiUserData?.bank_details?.bank_name);
      formData.append("bank_branch", bankIfscCodeList?.branchName ||  SaathiUserData?.bank_details?.bank_branch);
      formData.append("bank_document", selectedFile);
      formData.append("created_by", currentUser.sub);
      formData.append("created_by_name", currentUser.name);
      formData.append("applicant_id",id)
  
      fetch(`${API_URL}/empanelment/api/bank-details/`, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Token ${user_token}` },
      })
      .then(resp => {
        const result = resp
        if (result.status === 200 || result.status=== 201) {
          resp.json().then(response => {
            swal("Success", {
              buttons: false,
              icon: "success",
              title: response.message,
              timer: 1500,
            })
            setLoader(false)
            SaathiDetailsRefetch(id)
            setisEdit(false)
          }).catch(err => console.log(err))
       
        } else {
          result.json().then(response => {
            swal("...Ooops", {
              buttons: false,
              icon: "warning",
              title: response.message,
              timer: 1500,
            })
            setLoader(false)
          }).catch(err => console.log(err))
          
        }
      })
    };
  

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 48,
    }),
  };

  function capitalizeFirstLetter(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
}


  return (
    <Row>
      {SaathiUserData === undefined ? (
        <TableLoader />
      ) : (
        <>
          <CardHeader
            style={{ padding: "13px" }}
            className=" mb-3 d-flex justify-content-between align-items-center mt-3"
          >
            <h5 className="m-0">Banking Details </h5>

            { RolesFromToken.groups?.includes("Maker") ?     SaathiUserData?.onboarding_status === "QC1 Approved" ? "" : <div>  {isEdit ? (
            <Button
              size="sm"
              id="editDetails"
              type=""
              className=" btn-danger waves-effect  "
              onClick={() => setisEdit(false)}
            >
              Cancel <i className="mdi mdi-window-close"></i>
            </Button>
          ) : (
            <Button
              size="sm"
              id="editDetails"
              type=""
              className="  waves-effect  "
              onClick={() => setisEdit(true)}
            >
              Edit <i className="mdi mdi-file-edit-outline"></i>
            </Button>
          )}
          </div>  : ""}
          </CardHeader>
          <form onSubmit={handleSubmit(onSubmitSaathiData)}>
          <Row>
            {/* Banking Details */}

            <Col lg="3" className="mb-2">
              <Label>Account Holder Name</Label>
              <Input
                name="account_holder_name"
                defaultValue={SaathiUserData?.bank_details?.account_holder_name}
                disabled= {isEdit === true ? false :true}
                onChange={onInputChange}
                placeholder="Enter Name"
                className="input_text"
              />
            </Col>
            <Col lg="3" className="mb-2">
              <Label>Account Number</Label>
              <Input
              type="number"
                name="account_number"
                defaultValue={SaathiUserData?.bank_details?.account_number}
                disabled= {isEdit === true ? false :true}
                onChange={onInputChange}
                placeholder="Enter Account Number"
                className="input_text"
              />
            </Col>
           {isEdit === true  ?  <Col lg="3" className="mb-2">
              <Label>Select Account Type</Label>
              <Select
            
                    onChange={(AccountType) => {
                      handleAccountType(AccountType.value);
                    }}
                    options={AccountTypeListData}
                    styles={customStyles}
                    placeholder={capitalizeFirstLetter(SaathiUserData?.bank_details?.account_type) || "Select Account Type"}
                  />
            </Col> :  <Col lg="3" className="mb-2">
              <Label>Account Type</Label>
              <CustomTextField
                name=""
                defaultValue={SaathiUserData?.bank_details?.account_type}
                disabled
                placeholder="Select Account type"
              />
            </Col>  }
            {isEdit === true ? <Col lg="3" className="mb-2">
              <Label>Select IFSC Code</Label>
              <Select
                    options={BankIfscOptions}
                    onKeyDown={onIfscKeyUp}
                    onChange={onIfscChange}
                    styles={customStyles}
                    placeholder={SaathiUserData?.bank_details?.ifsc_code || "Select IFSC"}
                  />
            </Col> : <Col lg="3" className="mb-2">
              <Label>IFSC Code</Label>
              <CustomTextField
                name=""
                defaultValue={SaathiUserData?.bank_details?.ifsc_code}
                disabled
                placeholder="Select IFSC Code"
              />
            </Col> }

            <Col lg="3" className="mb-2">
              <Label>Bank Branch</Label>
              <CustomTextField
                name=""
                defaultValue={bankIfscCodeList?.branchName || SaathiUserData?.bank_details?.bank_branch}
                disabled
                // placeholder="Bank Name"
              />
            </Col>
            <Col lg="3" className="mb-2">
              <Label>Bank Name</Label>
              <CustomTextField
                name=""
                defaultValue={bankIfscCodeList?.bankName || SaathiUserData?.bank_details?.bank_name}
                disabled
                // placeholder="Branch Name"
              />

            </Col>
            {isEdit === true ? <Col lg="4" className="mb-2">
                <Label className="f_p f_400">
                  Upload cancelled Cheque
                  <small className="text-danger">*</small>
                  <small>(img, Doc Or Pdf Format Only*)</small>
                </Label>
                <input
                  type="file"
                  className="form-control"
                  id="OtherDocImg"
                  name="bank_document"
                  filename="selectedFile"
                  onChange={changeHandler}
                  accept="image/jpeg,image/png,application/pdf"
                />
              </Col>  :""}
          
              {isEdit === true ?   <div className="col-lg-12 text-center m-auto p-2">
                <button type="submit" className="btn btn-success p-3" >
                <span class="mdi mdi-content-save "></span> Update Banking Details &nbsp;{loader ? <Spinner animation="border" size="sm"></Spinner> : ""}
                </button>
              </div>: "" }
          </Row>
          </form>
        </>
      )}
    </Row>
  );
};

export default SaathiBankDetails;
